<!-- eslint-disable -->
<template lang="pug">
    .modal.conversation.is-active.hidmeinfirefox(ref='modal')
        .modal.conversation.is-active.hidmeinfirefox(ref='modal')
            .modal-background
            .modal-card
                section.modal-card-body.detective-conversation
                    template(v-if='!isLoading && isSoundsLoaded')
                        component(
                            :is='chapter',
                            :items='items',
                            :scene-name='itemName',
                            :clevik-src='clevikSrc',
                            :detective-src='detectiveSrc',
                            :is-introduction='isIntroduction',
                            :output='output',
                            :is-dialog-running='isDialogRunning',
                            :left-image-is-set='leftImageIsSet',
                            :right-image-is-set='rightImageIsSet',
                            :is-mobile='isMobile',
                            :is-element-clickable='isElementClickable',
                            :is-animation-finished='isAnimationFinished'
                        )
                            .conversation-block(
                                ref='chat',
                                :class="{'is-active': isDialogRunning}",
                                :style='conversationBlockWidth'
                            )
                                transition-group(name='speech' tag='div')
                                    .speech-bubble(
                                        v-if='output.length',
                                        v-for='(message, index) in output',
                                        :class='bubbleSourceClass(message)',
                                        :key='itemName + index',
                                        v-html='message.content'
                                    )
                            .detective__next-dialog-button(v-if='!isDialogRunning && !isMobile', @click="$emit('close')")
                                cs-button
                                    | {{ itemName !== 'eighthLetter' ? $i18n.t('common.common_navigation_backToRoom') : $i18n.t('common.common_button_collect') }}
                        .detective-conversation-buttons
                            a.button.delete(
                                v-if='isLetterSet'
                                @click="$emit('close')",
                                href='javascript://',
                                :class="{'is-disabled': isFirstTime && !replay}",
                                :title="$i18n.t('map.map_conversation_close')"
                            )
                            a.refresh-dialog-icon(
                                href='javascript://',
                                @click='refreshDialog',
                                :class="{'is-disabled': isButtonDisabled || isButtonRefreshing || !replay}",
                                :title="$i18n.t('map.map_conversation_playConversation')"
                            )
                                i.fa.fa-refresh

</template>

<script>
    /*eslint-disable*/
    const Chapter_1 = () => import('../../components/motivation/detective/conversation_chapters/Chapter_1.vue');
    const Chapter_2 = () => import('../../components/motivation/detective/conversation_chapters/Chapter_2.vue');
    const DELAY = 500;
    export default {
        components: {
            Chapter_1,
            Chapter_2
        },
        props: {
            items: Array,
            itemName: String,
            isFirstTime: Boolean,
            conversation: Array,
            sound: Array,
            detectiveSrc: String,
            clevikSrc: String,
            isMobile: Boolean,
            isIntroduction: Boolean,
            replay: Boolean,
            chapter: String,
            isLetterSet: Boolean,
            stageId: Number,
        },
        mounted () {
            this.isFirefox = !!navigator.userAgent.match(/firefox/ig);
            this.$refs.modal.addEventListener(this.isFirefox ? 'DOMMouseScroll' : 'mousewheel', this.scrollHandle);
            document.addEventListener('keydown', this.closeModalHandler);
            let mc = new Hammer.Manager(document.querySelector('.detective-conversation'));
            let Swipe = new Hammer.Swipe({
                event: 'swipe',
                pointers: 1,
                threshold: 5,
                direction: Hammer.DIRECTION_VERTICAL,
                velocity: 0.2
            });
            mc.add(Swipe);
            mc.on('swipe', (e) => _.throttle(this.scrollHandle, 2000)({...e, deltaY: -e.deltaY}));
            this.showingItems = this.items;
            this.registerSounds().then(this.showMessages).catch((err) => this.showErrorMessage(err));
        },
        beforeDestroy () {
            this.$refs.modal.removeEventListener(this.isFirefox ? 'DOMMouseScroll' : 'mousewheel', this.scrollHandle);
            document.removeEventListener('keydown', this.closeModalHandler);
            this.$createjs.Sound.removeAllSounds();
            this.$createjs.Sound.removeAllEventListeners();
        },
        data () {
            return {
                isLoading: false,
                isSoundsLoaded: false,
                isButtonDisabled: false,
                isDialogRunning: false,
                isFirefox: false,
                output: [],
                soundInstance: null,
                leftImageIsSet: false,
                rightImageIsSet: false,
                showingItems: [],
                isButtonRefreshing: false,
                isElementClickable: false,
                isAnimationFinished: true,
            }
        },
        methods: {
            bubbleSourceClass (message) {
                if (['seventhLetter', 'eighthLetter'].includes(this.itemName)) {
                    return message.source === 'clevik' ? 'right' : 'left';
                }
                return message.source === 'clevik' ? 'left' : 'right';
            },
            registerSounds () {
                return new Promise((resolve) => {
                    this.$createjs.Sound.removeAllSounds();
                    this.$createjs.Sound.removeAllEventListeners();
                    this.$createjs.Sound.on("fileload", () => {
                        this.isSoundsLoaded = true;
                        resolve();
                    });
                    this.$createjs.Sound.alternateExtensions = ["mp3"];
                    this.$createjs.Sound.registerSounds(this.sound);
                });
            },
            refreshDialog () {
                this.soundInstance && this.soundInstance.stop();
                this.isButtonRefreshing = true;
                this.output = [];
                this.hidePictures();
                this.$nextTick(() => {
                    this.output.push(this.conversation[0]);
                    this.$refs.chat.style['min-height'] = '0px';
                    this.isDialogRunning = true;
                    setTimeout(() => {
                        this.playSounds();
                        this.isButtonRefreshing = false;
                    }, DELAY)
                })
            },
            playSounds (index = 1) {
                if (this.isDialogRunning) {
                    this.soundInstance = this.$createjs.Sound.play(index);
                    if (this.replaceVoiceActingOnMusic) {
                        this.soundInstance.volume = 0;
                    }
                    this.soundInstance.on("complete", () => {
                        this.conversation.length > index && this.output.push(this.conversation[index]);
                        setTimeout(() => {
                            if (this.conversation.length > index) {
                                if (this.leftImageIsSet || this.rightImageIsSet) {
                                    this.hidePictures();
                                    setTimeout(() => this.addPictures(index), 1500)
                                } else {
                                    this.addPictures(index);
                                }
                                if (this.conversation[index - 1].interactive && this.isFirstTime) {
                                    this.stopDialog().then(() => {
                                        this.isElementClickable = false;
                                        setTimeout(() => {
                                            this.isAnimationFinished = true;
                                            this.isDialogRunning = true;
                                            this.playSounds(index + 1);
                                        }, 1000);
                                    });
                                }
                                this.playSounds(index + 1);
                            } else {
                                this.isDialogRunning = false;
                                this.$emit('handleDialogFinish');
                                if (this.conversation[this.conversation.length - 1].interactive) {
                                    this.stopDialog().then(() => {
                                        this.isElementClickable = false;
                                        setTimeout(() => {
                                            this.isAnimationFinished = true;
                                        }, 1000);
                                    });
                                }
                                if (!this.showingItems.includes(this.itemName)) {
                                    this.showingItems.push(this.itemName);
                                }
                                document.addEventListener('keydown', this.closeModalHandler);
                            }
                        }, DELAY)
                    })
                }
            },
            stopDialog () {
                this.isDialogRunning = false;
                this.isElementClickable = true;
                this.isAnimationFinished = false;
                return new Promise ((resolve) => {
                    this.$nextTick(() => {
                        document.querySelector('.interactive-block').addEventListener('click', () => {
                            resolve();
                        });
                    });
                });
            },
            addPictures(index = 0) {
                if ((this.conversation[index].leftImage)) {
                    document.getElementById('left__conversation-image').style.backgroundImage = "url('imgs/"
                       + this.conversation[index].leftImage + "')";
                    this.leftImageIsSet = true;
                }
                if ((this.conversation[index].rightImage)) {
                    document.getElementById('right__conversation-image').style.backgroundImage = "url('imgs/"
                       + this.conversation[index].rightImage + "')";
                    this.rightImageIsSet = true;
                }
            },
            hidePictures() {
                this.leftImageIsSet = false;
                this.rightImageIsSet = false;
            },
            showErrorMessage(err) {
                if (err.data) {
                    this.$toasted.error(err.data.message);
                    this.$router.push({ name: 'dashboard' });
                }
                err = (err.response && err.response.data) ? err.response.data : err;
                if (err && (err.status_code === 403 || err.status_code === 404)) {
                    this.$router.push({ name: 'dashboard' });
                    this.$toasted.error(err.message);
                }
            },
            showMessages () {
                if (this.isMobile) {
                    let sheet = document.styleSheets[0];
                    for (let i = 0; i < sheet.cssRules.length; i++) {
                        sheet.deleteRule(i);
                    }
                    for (let i = 0; i < sheet.rules.length; i++) {
                        sheet.removeRule(i);
                    }
                    if (['seventhLetter', 'eighthLetter'].includes(this.itemName)) {
                        sheet.insertRule(`.speech-bubble.left:before { background-image: url("${this.detectiveSrc}"); }`, 0);
                        sheet.insertRule(`.speech-bubble.right:before { background-image: url("${this.clevikSrc}"); }`, 0);
                    } else {
                        sheet.insertRule(`.speech-bubble.left:before { background-image: url("${this.clevikSrc}"); }`, 0);
                        sheet.insertRule(`.speech-bubble.right:before { background-image: url("${this.detectiveSrc}"); }`, 0);
                    }
                }
                if (this.isFirstTime) {
                    document.removeEventListener('keydown', this.closeModalHandler);
                    if (this.$refs.chat) {
                      this.$refs.chat.style['min-height'] = '0px';
                    }
                    this.isButtonDisabled = true;
                    this.isDialogRunning = true;

                    this.output.push(this.conversation[0]);

                    setTimeout(() => {
                        this.addPictures();
                        this.playSounds();
                    }, DELAY)
                } else {
                    if (this.$refs.chat) {
                      this.$refs.chat.style['min-height'] =
                        `calc(100% - ${window.innerWidth < 1024 ? window.innerWidth < 768 ? 0 : 15 : 20}rem + 0.5rem)`;
                    }
                    this.output.push(...this.conversation);
                }
            },
            scrollHandle (e) {
                if (!this.isDialogRunning && this.isSoundsLoaded) {
                    if (e[this.isFirefox ? 'detail' : 'deltaY'] < 0) {
                        this.output.length > 0 && this.output.pop();
                    } else {
                        this.conversation[this.output.length] && this.output.push(this.conversation[this.output.length])
                    }
                }
            },
            closeModalHandler (event) {
                event.preventDefault();
                if (event.keyCode === 27) {
                    this.$emit('close');
                }
            },
        },
        computed: {
            replaceVoiceActingOnMusic () {
                return this.$i18n.locale === 'bg' || this.$i18n.locale === 'uk';
            },
            conversationBlockWidth () {
                if (['seventhLetter', 'eighthLetter'].includes(this.itemName) && !this.isMobile) {
                    return 'width: 75%'
                }
                return 'width: 100%';
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/sass/detective/conversation-modal.scss";

    .modal {
        bottom: 0;
        left: 0;
        position: fixed;
        right: 0;
        top: 0;
        align-items: center;
        display: none;
        justify-content: center;
        overflow: hidden;
        z-index: 1986;
    }
    .modal.is-active {
        display: flex;
    }
    .modal-background {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
    }
    .modal-card-body {
        padding: 0 !important;
        overflow: auto;
    }
    .static-page {
        display: flex;
        justify-content: center;
    }
    .left-interlocutor, .right-interlocutor {
        width: 100%;
    }
    .detective__next-dialog-button {
        position: absolute;
        bottom: 0;
        width: 100%;
        margin-bottom: 3%;
        display: flex;
        justify-content: center;
    }
    .conversation-block {
        width: 100%;
        margin-bottom: 20rem;
    }
    .speech-bubble__continent-transition {
        @include media($lg) {
            width: 100%;
            max-width: none;
        };
    }
    .speech-bubble {
        transition: all 0.5s;
        opacity: 1;
        transform: translateY(0);
    }
    .conversation-buttons {
        transition: all 1s;
        opacity: 1;
    }
    .speech-enter-active {
        opacity: 0;
        transform: translateY(100px);
    }
    .speech-leave-active {
        opacity: 0;
        position: absolute;
        bottom: 0;
    }
    .right.speech-leave-active {
        right: 0;
    }
    .left.speech-leave-active {
        left: 0;
    }
    .fade-enter-active {
        opacity: 0;
    }
    @-webkit-keyframes tada {
        from {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
        }
        10%,
        20% {
            -webkit-transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -3deg);
            transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -3deg);
        }
        30%,
        50%,
        70%,
        90% {
            -webkit-transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, 3deg);
            transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, 3deg);
        }
        40%,
        60%,
        80% {
            -webkit-transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, -3deg);
            transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, -3deg);
        }
        to {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
        }
    }
    @keyframes tada {
        from {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
        }
        10%,
        20% {
            -webkit-transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -3deg);
            transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -3deg);
        }
        30%,
        50%,
        70%,
        90% {
            -webkit-transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, 3deg);
            transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, 3deg);
        }
        40%,
        60%,
        80% {
            -webkit-transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, -3deg);
            transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, -3deg);
        }
        to {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
        }
    }
    .tada {
        -webkit-animation-name: tada;
        animation-name: tada;
    }
    .animated {
        -webkit-animation-duration: 1.5s;
        animation-duration: 1.5s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }
    .animated.infinite {
        -webkit-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
    }
</style>
